<template>
  <div class="app-container">
    <!-- 搜索条件 -->
    <div class="filter-container">
      <el-input
        class="filter-item"
        v-model="listQuery.order_id"
        placeholder="订单号"
        style="width: 180px"
        clearable
        @keyup.enter.native="handleFilter"
      />
      <el-input
        class="filter-item"
        v-model="listQuery.system_order_no"
        placeholder="系统订单号"
        style="width: 180px"
        clearable
        @keyup.enter.native="handleFilter"
      />
      <el-input
        class="filter-item"
        v-model="listQuery.order_code"
        placeholder="供应商订单号"
        style="width: 180px"
        clearable
        @keyup.enter.native="handleFilter"
      />
      <el-input
        class="filter-item"
        v-model="listQuery.hotel_name"
        placeholder="酒店名称"
        style="width: 180px"
        clearable
        @keyup.enter.native="handleFilter"
      />
      <el-date-picker
        class="filter-item"
        v-model="changeTimeRange"
        type="daterange"
        range-separator="至"
        start-placeholder="修改开始时间"
        end-placeholder="修改结束时间"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        style="width: 340px"
      />
      <el-select
        class="filter-item"
        v-model="listQuery.change_type"
        placeholder="修改类型"
        style="width: 160px"
        clearable
      >
        <el-option
          v-for="opt in changeTypeOptions"
          :key="opt.value"
          :label="opt.label"
          :value="opt.value"
        />
      </el-select>
      <el-select
        class="filter-item"
        v-model="listQuery.change_category"
        placeholder="修改大类"
        style="width: 160px"
        clearable
      >
        <el-option
          v-for="opt in changeCategoryOptions"
          :key="opt.value"
          :label="opt.label"
          :value="opt.value"
        />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
      >
        搜索
      </el-button>
    </div>
    <div
      style="margin-bottom: 10px; display: flex; gap: 10px; align-items: center"
    >
      <el-tag type="success" size="mini">绿色当前值</el-tag>
      <el-tag type="danger" size="mini">红色修改前值</el-tag>
      <span style="font-size: 12px; color: #999">
        仅显示有变更的字段（红色旧值 + 绿色新值），未变更字段只显示绿色当前值
      </span>
    </div>
    <!-- 数据表格 -->
    <el-table
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
      size="small"
    >
      <el-table-column label="修改类型" align="center" width="100">
        <template slot-scope="scope">
          {{ scope.row.change_type_text }}
        </template>
      </el-table-column>

      <el-table-column label="修改时间" align="center" width="160">
        <template slot-scope="scope">
          {{ scope.row.change_time }}
        </template>
      </el-table-column>

      <el-table-column label="修改人" align="center" width="100">
        <template slot-scope="scope">
          {{ scope.row.change_by }}
        </template>
      </el-table-column>

      <el-table-column
        label="订单号"
        align="center"
        width="180"
        prop="order_no"
      >
        <template slot-scope="scope">
          {{ scope.row.order_no || '-' }}
        </template>
      </el-table-column>

      <el-table-column
        label="系统订单号"
        align="center"
        width="180"
        prop="system_order_no"
      >
        <template slot-scope="scope">
          {{ scope.row.system_order_no || '-' }}
        </template>
      </el-table-column>

      <el-table-column
        label="供应商订单号"
        align="center"
        width="180"
        prop="order_code"
      >
        <template slot-scope="scope">
          {{ scope.row.order_code || '-' }}
        </template>
      </el-table-column>

      <el-table-column
        label="确认号"
        align="center"
        width="120"
        prop="order_confirm_no"
      >
        <template slot-scope="scope">
          {{ scope.row.order_confirm_no || '-' }}
        </template>
      </el-table-column>

      <el-table-column
        label="酒店名称"
        align="center"
        width="160"
        prop="inn_name"
      >
        <template slot-scope="scope">
          {{ scope.row.inn_name || '-' }}
        </template>
      </el-table-column>

      <el-table-column
        label="入住时间"
        align="center"
        width="110"
        prop="travel_date"
      >
        <template slot-scope="scope">
          {{ scope.row.travel_date || '-' }}
        </template>
      </el-table-column>

      <el-table-column
        label="离店时间"
        align="center"
        width="110"
        prop="end_travel_date"
      >
        <template slot-scope="scope">
          {{ scope.row.end_travel_date || '-' }}
        </template>
      </el-table-column>

      <el-table-column
        label="实际离店时间"
        align="center"
        width="140"
        prop="actual_end_travel_date"
      >
        <template slot-scope="scope">
          <render-field :field="scope.row.fields?.actual_end_travel_date" />
        </template>
      </el-table-column>

      <el-table-column
        label="售卖房型"
        align="center"
        width="140"
        prop="room_type_name"
      >
        <template slot-scope="scope">
          {{ scope.row.room_type_name || '-' }}
        </template>
      </el-table-column>

      <el-table-column
        label="合作商渠道价"
        align="center"
        width="110"
        prop="actual_channel_money"
      >
        <template slot-scope="scope">
          <render-field :field="scope.row.fields?.actual_channel_money" />
        </template>
      </el-table-column>

      <el-table-column
        label="已扣额度"
        align="center"
        width="100"
        prop="quota_value"
      >
        <template slot-scope="scope">
          <render-field :field="scope.row.fields?.quota_value" />
        </template>
      </el-table-column>

      <el-table-column
        label="供应商成本价"
        align="center"
        width="110"
        prop="cost_price"
      >
        <template slot-scope="scope">
          <render-field :field="scope.row.fields?.actual_total_rate" />
        </template>
      </el-table-column>

      <el-table-column label="供应商订单状态" align="center" width="120">
        <template slot-scope="scope">
          <render-field
            :field="formatOrderState(scope.row.fields?.order_state)"
          />
        </template>
      </el-table-column>

      <el-table-column label="系统订单状态" align="center" width="120">
        <template slot-scope="scope">
          <render-field
            :field="
              formatSystemOrderStatus(scope.row.fields?.system_order_status)
            "
          />
        </template>
      </el-table-column>

      <!-- <el-table-column
        label="回退时间"
        align="center"
        width="160"
        prop="rollback_time"
      >
        <template slot-scope="scope">
          {{ scope.row.rollback_time || '-' }}
        </template>
      </el-table-column> -->

      <el-table-column label="操作" align="center" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleViewDetail(scope.row)"
          >
            订单详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination
        background
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 订单详情弹窗 -->
    <el-dialog
      title="订单详情"
      :visible.sync="dialogVisibleOrderDetail"
      :close-on-click-modal="false"
      width="80%"
      top="30px"
      @closed="handleOrderDetailClosed"
    >
      <orderDetailShow
        :orderId="orderDetailId"
        dialogMode
        v-if="dialogVisibleOrderDetail"
      />
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import orderDetailShow from './orderDetailShow.vue'

/* 字段渲染组件：有修改显示红绿块，无修改显示绿块 */
const RenderField = {
  functional: true,
  props: {
    field: { type: Object, default: null },
  },
  render(h, ctx) {
    const field = ctx.props.field
    if (!field) {
      return h('span', '-')
    }
    if (
      field.old_value !== undefined &&
      field.old_value !== null &&
      field.old_value !== ''
    ) {
      // 有修改：红块(旧值) + 绿块(新值)
      return h(
        'div',
        {
          style: {
            display: 'flex',
            'flex-direction': 'column',
            gap: '4px',
            'align-items': 'center',
          },
        },
        [
          h('el-tag', { props: { type: 'danger' } }, field.old_value),
          h('el-tag', { props: { type: 'success' } }, field.new_value),
        ],
      )
    }
    // 未修改：绿块显示当前值
    return h('el-tag', { props: { type: 'success' } }, field.new_value || '-')
  },
}

export default {
  name: 'OrderChangeLog',
  components: {
    RenderField,
    orderDetailShow,
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: false,
      changeTimeRange: [],
      changeTypeOptions: [],
      changeCategoryOptions: [],
      dialogVisibleOrderDetail: false,
      orderDetailId: '',
      listQuery: {
        page: 1,
        limit: 10,
        order_id: '',
        system_order_no: '',
        order_code: '',
        hotel_name: '',
        change_start_time: '',
        change_end_time: '',
        change_type: '',
        change_category: '',
      },
    }
  },
  async created() {
    // 从查询参数中预填订单号
    if (this.$route.query.system_order_no) {
      this.listQuery.system_order_no = this.$route.query.system_order_no
    }
    await this.fetchChangeTypeOptions()
    this.getList()
  },
  watch: {
    changeTimeRange(val) {
      if (val && val.length === 2) {
        this.listQuery.change_start_time = val[0]
        this.listQuery.change_end_time = val[1]
      } else {
        this.listQuery.change_start_time = ''
        this.listQuery.change_end_time = ''
      }
    },
  },
  methods: {
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/order/fieldLogList',
        method: 'get',
        params: this.listQuery,
      })
        .then((response) => {
          console.log(response)

          this.list = (response.data.data || []).map((item) => {
            const fields = {}
            const changeDetails = item.change_details || []
            changeDetails.forEach((detail) => {
              if (detail.field) {
                fields[detail.field] = {
                  old_value: detail.old_value,
                  new_value: detail.new_value,
                }
              }
            })
            const snapshot = item.snapshot || {}
            const allFields = [
              'actual_channel_money',
              'quota_value',
              'actual_total_rate',
              'order_state',
              'system_order_status',
              'actual_end_travel_date',
            ]
            allFields.forEach((key) => {
              if (!fields[key] && snapshot[key] !== undefined) {
                fields[key] = { new_value: snapshot[key] }
              }
            })
            item.fields = fields
            const typeMap = {}
            this.changeTypeOptions.forEach((o) => {
              typeMap[o.value] = o.label
            })
            item.change_type_text =
              typeMap[item.change_type] || item.change_category_label || '-'
            item.change_time = item.created_at || '-'
            item.change_by =
              item.operator_username ||
              (item.operator_id ? `操作员#${item.operator_id}` : '-')
            Object.keys(snapshot).forEach((key) => {
              if (item[key] === undefined) {
                item[key] = snapshot[key]
              }
            })
            item.order_no = item.order_id || snapshot.order_id || '-'
            return item
          })
          this.total = response.data.total || 0
        })
        .catch(() => {
          this.$message.error('获取订单修改记录失败')
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    fetchChangeTypeOptions() {
      return request({
        url: '/api/backend/order/changeTypeOptions',
        method: 'get',
      })
        .then((res) => {
          this.changeTypeOptions = res.data.change_type_options || []
          this.changeCategoryOptions = res.data.change_category_options || []
        })
        .catch(() => {})
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    formatOrderState(field) {
      if (!field) return field
      const map = {
        1: '预订成功',
        2: '已取消',
        3: '预订未到',
        4: '已入住',
        5: '已完成',
      }
      const result = { ...field }
      if (result.old_value)
        result.old_value = map[result.old_value] || result.old_value
      if (result.new_value)
        result.new_value = map[result.new_value] || result.new_value
      return result
    },
    formatSystemOrderStatus(field) {
      if (!field) return field
      const map = {
        100: '下单待处理',
        101: '下单成功',
        102: '下单失败',
        103: '下单确认中',
        201: '取消订单成功',
        202: '取消订单失败',
        203: '取消订单中',
      }
      const result = { ...field }
      if (result.old_value)
        result.old_value = map[result.old_value] || result.old_value
      if (result.new_value)
        result.new_value = map[result.new_value] || result.new_value
      return result
    },
    handleViewDetail(row) {
      const orderId = row.order_id || row.order_no
      if (orderId) {
        this.orderDetailId = orderId
        this.dialogVisibleOrderDetail = true
      } else {
        this.$message.warning('缺少订单ID，无法查看详情')
      }
    },
    handleOrderDetailClosed() {
      this.orderDetailId = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-container {
  padding-bottom: 16px;
  .filter-item {
    margin-bottom: 10px;
    margin-right: 10px;
    vertical-align: top;
  }
}

.pagination-container {
  margin-top: 16px;
  text-align: center;
}
</style>
